import ScrollMagic from "scrollmagic/scrollmagic/uncompressed/ScrollMagic";

if (document.documentElement.clientWidth > 981) {

let controller = new ScrollMagic.Controller();

let scene1 = new ScrollMagic.Scene({
    triggerElement: '.header'
  })

  .setClassToggle('.header-banner', 'anim')
  .addTo(controller);


let scene2 = new ScrollMagic.Scene({
    triggerElement: '.person'
  })

  .setClassToggle('.person', 'animation')
  .addTo(controller);

let scene3 = new ScrollMagic.Scene({
    triggerElement: '.targets'
  })

  .setClassToggle('.targets', 'targets-animation')
  .addTo(controller);


let scene5 = new ScrollMagic.Scene({
  triggerElement: '.promotions'
})
.on('enter', function () {
  animateText('targetsText');
  animateText('targetsText1');
  animateText('targetsText2');
})
.on("leave", function(){
  
  var items = document.querySelectorAll(".text-anim");
  items.forEach(function(item){
    item.classList.add('hidden');
  })
  
})
.addTo(controller);
function animateText(textElemId) {

  let text = document.getElementById(textElemId);
  let newDom = '';
  let animationDelay = 6;
  text.classList.remove('hidden');
  for (let i = 0; i < text.innerText.length; i++) {
    newDom += '<span class="char">' + (text.innerText[i] == ' ' ? '&nbsp;' : text.innerText[i]) + '</span>';
  }

  text.innerHTML = newDom;
  let length = text.children.length;

  for (let i = 0; i < length; i++) {
    text.children[i].style['animation-delay'] = animationDelay * i + 'ms';
  }
}

let scene6 = new ScrollMagic.Scene({
  triggerElement: '.shedule'
})

.setClassToggle('.shedule-list', 'shedule-list-animation')
.addTo(controller);

let scene7 = new ScrollMagic.Scene({
  triggerElement: '.program-content'
})

.setClassToggle('.program-content', 'program-content-animation')
.addTo(controller);
}